module.exports = __webpack_public_path__ + "img/icon-competence-1.af6b3cb2.svg";